module.exports = __webpack_public_path__ + "static/media/water-and-waste.62bd457f.svg";